RivalIQ.apps.Favorites.module('views.selectors', function (selectors, App, Backbone, Marionette, $, _, s) {

    'use strict';

    const NO_BENCHMARK = 'NO_BENCHMARK';
    const CUSTOM_SUMMARY = 'CUSTOM_SUMMARY';
    const PREVIOUS_PERIOD = 'previousPeriod';

    function getAllItems(focusWidget) {
        let noBenchmarkName = 'None';

        if (focusWidget.getBenchmarkItems) {
            return focusWidget.getBenchmarkItems();
        }

        if (focusWidget.widgetId === RivalIQ.enums.widgetTypes.FOCUS_COMPANY_GLANCE) {
            noBenchmarkName = 'Previous Period';
        }

        let description = RivalIQ.strings.favorites_builder_benchmark_none_description;
        if (_.includes([RivalIQ.enums.widgetTypes.METRIC_TABLE, RivalIQ.enums.widgetTypes.COMPANY_TABLE], focusWidget.widgetId)) {
            description = RivalIQ.strings.favorites_builder_benchmark_none_table_description;
        }

        const applicableBenchmarks = _.filter(RivalIQ.enums.benchmarkCompareAgainstOptions, benchmarkCompareAgainstOption => {
            return _.includes(['average', 'median'], benchmarkCompareAgainstOption.aggregate);
        });

        const items = [{
            id: NO_BENCHMARK,
            name: noBenchmarkName,
            description: description
        }].concat(applicableBenchmarks);

        if (App.data.chartTypes[focusWidget.widgetId].widgetSupportsCustomSummary && RivalIQ.state.plan.get('has_multi_handle_private_advanced')) {
            items.push({
                id: CUSTOM_SUMMARY,
                name: 'Custom Aggregations',
                description: 'Displays summary values for each metric. Options include average, median, or sum.'
            });
        }

        return items;
    }

    selectors.Benchmark = RivalIQ.views.Select.extend({
        template: '#benchmarkSelectTemplate',

        onChange: function (showBenchmarkOption) {
            const me = this;

            const newProps = {};
            if (showBenchmarkOption === NO_BENCHMARK) {
                newProps.showBenchmarkLine = false;
                newProps.selectedBenchmarkCompareAgainst = undefined;
                newProps.showCustomSummary = false;
            } else if (showBenchmarkOption === CUSTOM_SUMMARY) {
                newProps.showBenchmarkLine = false;
                newProps.selectedBenchmarkCompareAgainst = undefined;
                newProps.showCustomSummary = true;
            } else {
                newProps.showBenchmarkLine = true;
                newProps.selectedBenchmarkCompareAgainst = showBenchmarkOption;
                newProps.showCustomSummary = false;
            }

            me.dashboardModel.getWidget().setProps(newProps, {
                navigate: false
            });
        },

        _resetState: function () {
            const me = this;

            const focusWidget = me.dashboardModel.getWidget();
            const widgetSupportsBenchmarkLine = _.result(focusWidget, 'widgetSupportsBenchmarkLine');
            const metricSupportsBenchmarkLine = _.result(focusWidget, 'metricSupportsBenchmarkLine');

            if (widgetSupportsBenchmarkLine && metricSupportsBenchmarkLine) {
                me.items = getAllItems(focusWidget);
                const compareAgainst = focusWidget.getProp('selectedBenchmarkCompareAgainst');

                if (focusWidget.isLandscapeAggregateWidget) {
                    if (compareAgainst === PREVIOUS_PERIOD) {
                        me.selected = compareAgainst;
                    } else {
                        me.selected = NO_BENCHMARK;
                    }
                } else {
                    const widgetSupportsCustomSummary = _.result(focusWidget, 'widgetSupportsCustomSummary');
                    if (widgetSupportsCustomSummary && focusWidget.getProp('showCustomSummary')) {
                        me.selected = CUSTOM_SUMMARY;
                    } else {
                        const selectedBenchmarkCompareAgainst = RivalIQ.apps.Overview.utils.getSelectedBenchmarkCompareAgainst(compareAgainst);
                        if (selectedBenchmarkCompareAgainst && focusWidget.getProp('showBenchmarkLine')) {
                            me.selected = selectedBenchmarkCompareAgainst.id;
                        } else {
                            me.selected = NO_BENCHMARK;
                        }
                    }
                }
            } else {
                // reset prop state if a benchmark was previously selected
                const widget = me.dashboardModel.getWidget();
                if (widget.getProp('showBenchmarkLine')) {
                    const newProps = {
                        showBenchmarkLine: false,
                        selectedBenchmarkCompareAgainst: undefined
                    };
                    widget.setProps(newProps, {
                        navigate: false
                    });
                }

                me.items = [];
            }
        },

        initialize: function (options) {
            const me = this;

            _.extend(me, options);
            me._resetState();
        },

        resetSelector: function () {
            const me = this;

            me._resetState();
            me.setItems(me.items, me.selected);
        }
    });

}, window.s);
